import { FileSpreadsheet, GitFork, MessagesSquare } from 'lucide-react'

const PAINS = [
  {
    icon: FileSpreadsheet,
    title: 'Tablisalarda bahalamak',
    body: 'Bahalar tablisalaryň arasynda göçürilýär. Sanlara hiç kim ynanmaýar.',
  },
  {
    icon: GitFork,
    title: 'Her saparda warianty bar',
    body: 'Göni ýa-da geçiş. Bir ulag ýa-da iki. El bilen deňeşdirmek haýal.',
  },
  {
    icon: MessagesSquare,
    title: 'E-poçtada ýitýän teklipler',
    body: 'Üç wariant iberildi, jogap çat-da geldi. Iki sany hakyky çeşme.',
  },
]

export function Problem() {
  return (
    <section id="problem" className="border-b border-border">
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="max-w-2xl mb-10">
          <p className="eyebrow text-primary mb-3">Mesele</p>
          <h2 className="text-[28px] sm:text-[36px] leading-tight font-semibold tracking-tight">
            Ýük daşama işleri logistika üçin ýasalmadyk gurallarda alnyp barylýar.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border rounded-2xl overflow-hidden border border-border">
          {PAINS.map(({ icon: Icon, title, body }) => (
            <div key={title} className="bg-background p-6">
              <div className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center text-muted-foreground mb-4">
                <Icon className="w-4 h-4" />
              </div>
              <h3 className="text-[17px] font-semibold tracking-tight mb-2">{title}</h3>
              <p className="text-[14.5px] text-muted-foreground leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
